import { firebase } from '../config/configureFirebase';
import store from '../store/store';

const getApiHost = () => {
  const { config } = firebase;
  const settings = store.getState()?.settingsdata?.settings;
  if (typeof window !== 'undefined' && window.location?.origin && settings?.CompanyWebsite === window.location.origin) {
    return window.location.origin;
  }
  return `https://${config.projectId}.web.app`;
};

async function authFetch(path, options = {}) {
  const auth = firebase.auth;
  const user = auth && auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  const idToken = await user.getIdToken();

  const res = await fetch(`${getApiHost()}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...(options.headers || {}),
    },
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json.error || `HTTP ${res.status}`);
  }
  return json;
}

export const getAutoRechargeSettings = () =>
  authFetch('/auto-recharge-settings-get', { method: 'GET' });

export const saveAutoRechargeSettings = (payload) =>
  authFetch('/auto-recharge-settings', { method: 'POST', body: JSON.stringify(payload) });

export const requestDaviplataSubscription = (payload) =>
  authFetch('/daviplata-request-subscription', { method: 'POST', body: JSON.stringify(payload) });

export const activateDaviplataSubscription = (payload) =>
  authFetch('/daviplata-activate-subscription', { method: 'POST', body: JSON.stringify(payload) });

export const cancelDaviplataSubscription = () =>
  authFetch('/daviplata-cancel-subscription', { method: 'POST', body: JSON.stringify({}) });
